export class DriverRankTierVehicleDistanceRateEntity {
  id?: string
  tierConfigId?: string
  vehicleTemplateId?: number
  pickupFee?: number
  dropoffFee?: number
  additionalFee?: number
  distanceFeePerKm?: number
}
